import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, input } from '@angular/core';

@Component({
  selector: 'app-metro-button',
  standalone: false,
  templateUrl: './metro-button.component.html',
})
export class MetroButtonComponent {
  @Input() text: string = '';
  @Input() variant: 'primary' | 'secondary' | 'danger' | 'custom' = 'primary';
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = true;
  @Input() error: string | null = null;
  // @Input() customColor: string = '#0c7ff2';
  @Input() priority: 'high' | 'medium' | 'low' = 'medium';
  @Input() size: 'sm' | 'md' | 'lg' | 'icon' = 'md';
  // @Input() customClass: string = '';
  @Input() customColor: string = '#1C2D36'; // background
  @Input() customTextColor: string = '#ffffff'; // texto
  @Input() customClass: string = '';
  @Input() loading: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  // Íconos
  @Input() icon?: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() iconSize: string = '20';
  @Input() iconColor: string = '#1C2D36';

  @Output() clicked = new EventEmitter<void>();

  get buttonStyles() {
    if (this.variant === 'custom') {
      return {
        'background-color': this.customColor,
        'color': this.customTextColor,
      };
    }
    return {};
  }


  private getContrastColor(): string {
    if (!this.customColor) return '#ffffff';
    const hex = this.customColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#ffffff';
  }

  onClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
